import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {}

export const setAction_Costs = ({ eventEmitter }: Props) => {
    apiProvider.setActiveAction({action: 'cost_discovery_rules'})
    eventEmitter.emit(Event.setActionBar_Costs);
};
